<script>
import SetupProfile from './SetupProfile.vue'
import MultiSelect from '@/components/registration/MultiSelect.vue'
import IbanNumber from '@/components/registration/IbanNumber.vue'
import { mapGetters } from 'vuex'
import AnnualIncome from '@/components/registration/AnnualIncome.vue'

export default {
    // End of Component > extends

    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        MultiSelect,
        IbanNumber,
        AnnualIncome
    },
    /*
  |--------------------------------------------------------------------------
  | Component > extends
  |--------------------------------------------------------------------------
  */
    extends: SetupProfile, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            section: 'account-info',
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['form']),
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */

        async onSubmit() {
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                /*
                |--------------------------------------------------------------------------
                | Work Type ID hardcoded
                |--------------------------------------------------------------------------
                */
                // this.$store.commit('updateField', {
                //     key: 'occupationInfo.workTypeId',
                //     value: "5d429fa7fe1478e83fe04955",
                // })
                // END
                this.$store.commit('updateField', {
                    key: 'forms.form3.valid',
                    value: true,
                })

                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-kyc',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push({ name: 'edit-kyc' })
                }

                // console.log(
                //     'HereUs: ' +
                //         JSON.stringify(this.$store.state.registration.form)
                // )
            } else {
                this.$store.commit('updateField', {
                    key: 'forms.form3.valid',
                    value: false,
                })
                // console.log("account info errors",this.errors.all())
                this.$store.commit('setError', this.errors.all()[0])
            }
            // validate the form fields
            // const result = await this.$validator.validateAll()
            //
            // // Check if validation fails
            // if (result) {
            //     this.$store.commit('setLoading', true)
            //
            //     let registrationUrl = '/customers/face-to-face'
            //
            //     if (this.$route.meta.publicRegistration === true) {
            //         registrationUrl = '/customers/non-face-to-face'
            //     }
            //
            //     try {
            //         const formData = this.$store.state.registration.form
            //         formData.dataSegmentId = this.dataSegmentId
            //
            //         const { data } = await request({
            //             url: registrationUrl,
            //             method: 'post',
            //             data: formData,
            //         })
            //
            //         this.$store.commit('updateField', {
            //             key: 'idenfoId',
            //             value: data.data.idenfoId,
            //         })
            //
            //         if (this.$route.meta.publicRegistration === true) {
            //             this.$router.push({
            //                 name: 'public-registration-finish',
            //                 params: {
            //                     dataSegmentId: this.dataSegmentId,
            //                 },
            //             })
            //         } else {
            //             this.$router.push('/register-customer/finish')
            //         }
            //     } catch (errors) {
            //         this.$store.commit('setError', errors)
            //     }
            //     this.$store.commit('setLoading', false)
            // } else {
            //     this.$store.commit('setError', this.errors.all()[0])
            // }
        }, // End of onSubmit() method

        onBack() {
            this.$router.push({
                name: 'edit-setup-profile',
            })
        },
        // async onSave() {
        //     // this.$store.commit('setLoading', true)
        //     // if (this.$route.meta.publicRegistration === true) {
        //     //     this.$refs.termsandconditionmodal.show()
        //     // } else {
        //         let registrationUrl = '/customers/update-individual-customer'
        //         this.$store.commit('setLoading', true)

        //         try {
        //             const formData = this.$store.state.registration.form
        //             // formData.dataSegmentId = this.dataSegmentId

        //             const { data } = await request({
        //                 url: registrationUrl,
        //                 method: 'post',
        //                 data: formData,
        //             })

        //            this.$toasted.show(
        //                     'Changes saved successfully',
        //                     {
        //                         duration: 3000,
        //                         type: ['success'],
        //                     }
        //                 )

        //             this.$store.commit('setLoading', false)
        //         } catch (errors) {
        //             this.$store.commit('setError', errors)
        //             this.$store.commit('setLoading', false)
        //         }
        //     // }
        // },
    }, // End of Component > methods
} // End of export default
</script>
